var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17517 13.2174H8.82546C6.42208 13.2174 4.47399 11.2927 4.47399 8.92033V4.29706C4.47399 1.92373 6.42208 0 8.82546 0H9.17517C11.5786 0 13.5276 1.92373 13.5276 4.29706V8.92033C13.5276 11.2927 11.5786 13.2174 9.17517 13.2174ZM15.5628 8.78287C15.5628 8.25386 15.9968 7.82626 16.5315 7.82626C17.0663 7.82626 17.5002 8.25386 17.5002 8.78287C17.5002 13.0866 14.2008 16.6404 9.96944 17.1178V19.0434C9.96944 19.5714 9.53546 20 9.00073 20C8.46503 20 8.03201 19.5714 8.03201 19.0434V17.1178C3.79969 16.6404 0.500244 13.0866 0.500244 8.78287C0.500244 8.25386 0.934229 7.82626 1.46896 7.82626C2.00369 7.82626 2.43768 8.25386 2.43768 8.78287C2.43768 12.3558 5.38161 15.2629 9.00073 15.2629C12.6189 15.2629 15.5628 12.3558 15.5628 8.78287Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.5426b684.svg";
export { ForwardRef as ReactComponent };